"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoTypes = void 0;
var AlgoTypes;
(function (AlgoTypes) {
    AlgoTypes["standard"] = "sha512";
    AlgoTypes["pbkdf2"] = "pbkdf2-sha512";
    AlgoTypes["aes_cbc"] = "aes-512-cbc";
    AlgoTypes["aes_gcm"] = "aes-512-gcm";
})(AlgoTypes || (exports.AlgoTypes = AlgoTypes = {}));
//# sourceMappingURL=algoTypes.js.map